import { BrandCode } from 'types';
import { getTargetedOffersLogin } from './getTargetedOffersLogin';
import { validateFormatInvalidLoginTargetedOffer } from './validateFormatInvalidLoginTargetedOffer';

export const getStateTargetedOffer = async ({
  updateState,
  apolloClient,
  brand,
  globalization,
  input,
  targetedOffersLoading,
  showTargetedOffersPerksQualifiers,
  config,
}) => {
  const { filtersDictionary } = globalization.dictionaries;
  const {
    errorMyOffersInvalidCrownAndAnchorSocietyID_RCI,
    errorMyOffersInvalidCrownAndAnchorSocietyID_CEL,
    errorMyOffersInvalidEmai,
  } = filtersDictionary;

  
  const errorMyOffersInvalidID = {
    [BrandCode.RoyalCaribbean]: [errorMyOffersInvalidCrownAndAnchorSocietyID_RCI],
    [BrandCode.Celebrity]: [errorMyOffersInvalidCrownAndAnchorSocietyID_CEL],
  };

  const loginValidation = validateFormatInvalidLoginTargetedOffer({
    updateState,
    globalization,
    input,
    brand,
  });

  if (loginValidation.loyaltyID || loginValidation.email) {
    input.loyaltyID = !loginValidation.loyaltyID ? null : input.loyaltyID;
    input.email = !loginValidation.email ? null : input.email;

    const newTargetedOfferState = await getTargetedOffersLogin({
      input,
      showTargetedOffersPerksQualifiers,
      apolloClient,
      brand,
      config,
    });

    const errorMessage = input.loyaltyID
      ? errorMyOffersInvalidID[brand]
      : errorMyOffersInvalidEmai;
    const errorTargetedOfferMessage =
      !newTargetedOfferState.isValid && errorMessage;

    updateState({
      ...newTargetedOfferState.data,
      errorTargetedOfferMessage,
      isInvalidEmailOrCASId: !newTargetedOfferState.isValid,
      loginOrigin: input.origin || input.originCall,
      loyaltyIDOrEmailLogin: input.loyaltyID || input.email,
    });

    return newTargetedOfferState;
  }

  if (targetedOffersLoading) {
    updateState({
      targetedOffersLoading: false,
    });
  }
  return {};
};
